/* eslint-disable */
import arrayIncludes from 'array-includes/polyfill';
import objectValues from 'object.values/polyfill';
import objectEntries from 'object.entries/polyfill';
import 'string.prototype.includes';

// This import must come after the above imports, or IE11 will break.
import 'react-app-polyfill/ie11';

// Apply polyfills manually
Array.prototype.includes = arrayIncludes();
Object.values = objectValues();
Object.entries = objectEntries();

import React from 'react';
import ReactDOM from 'react-dom';
import Raven from "raven-js";

import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./_app/logging/sentry";

import './index.css';
import App from './_app/App';
import registerServiceWorker from './_app/registerServiceWorker';
import AppWrapper from './_app/AppWrapper';

document.title = "Peachjar School Onboarding";

ReactDOM.render(<AppWrapper />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js